import { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { IIconProps } from "../../../../assets/icons/icon";

export const NutrientIndicatorExplanationHero: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  const translator = useTranslation().t;
  const t = useCallback((key: string) => translator(`micronutrient.explanation.hero.${key}`), [translator]);

  return (
    <svg viewBox="0 0 737 317" {...rest} style={{ ...rest.style, textRendering: "geometricPrecision" }}>
      <defs>
        <rect id="path-difr74wstm-1" x="2" y="2" width="328" height="210" rx="16"></rect>
        <rect id="path-difr74wstm-3" x="0" y="2" width="132" height="6" rx="3"></rect>
      </defs>
      <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="11a-Mikronährstoffe" transform="translate(-546.000000, -368.000000)">
          <g id="Card" transform="translate(521.000000, 160.000000)">
            <g id="Infocard" transform="translate(25.926993, 208.000000)">
              <g id="UI-Elements/Card/Nährstoffe" transform="translate(217.000000, 41.000000)">
                <mask id="mask-difr74wstm-2" fill="white">
                  <use href="#path-difr74wstm-1"></use>
                </mask>
                <rect stroke="#82BECC" strokeWidth="2" x="1" y="1" width="330" height="212" rx="16"></rect>
                <g id="Group" mask="url(#mask-difr74wstm-2)">
                  <g transform="translate(289.000000, 17.000000)">
                    <g transform="translate(4.000000, 4.000000)">
                      <circle
                        id="Oval"
                        stroke="#222222"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        cx="8"
                        cy="8"
                        r="8"
                      ></circle>
                      <path
                        d="M8.91,5.61 L8.91,4 L7.05,4 L7.05,5.61 L8.91,5.61 Z M8.91,11.88 L8.91,6.8 L7.07,6.8 L7.07,11.88 L8.91,11.88 Z"
                        id="i"
                        fill="#222222"
                        fillRule="nonzero"
                      ></path>
                    </g>
                  </g>
                </g>
                <g id="Infos" mask="url(#mask-difr74wstm-2)">
                  <g transform="translate(20.000000, 16.000000)">
                    <text id="Vitamin-B1" fontFamily="Helvetica" fontSize="18" fontWeight="normal">
                      <tspan x="0" y="18" fill="#222222" fontWeight="bold">
                        {t("card.header")}
                      </tspan>
                    </text>
                    <g id="Funktion" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000, 24.000000)">
                      <text
                        id="Abbau-von-Fettsäuren"
                        fontFamily="Helvetica"
                        fontSize="16"
                        fontWeight="normal"
                        line-spacing="24"
                        fill="#222222"
                      >
                        <tspan x="19" y="19">
                          {t("card.line_1")}
                        </tspan>
                      </text>
                      <g
                        id="Group"
                        transform="translate(0.000000, 6.000000)"
                        stroke="#222222"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.16666667"
                      >
                        <g id="Group" transform="translate(1.166667, 1.166667)">
                          <path
                            d="M11.297522,1.59335998 L9.5607876,3.32964874 L8.33664378,3.32964874 L8.33664378,2.10544997 L10.0728546,0.368637608 C8.97452855,-0.231316273 7.61964169,-0.0894739409 6.66937235,0.724946223 C5.71910302,1.53936639 5.37150521,2.8566239 5.79620501,4.03390337 L0.38075609,9.4475009 C0.0523736227,9.77589811 -0.0758743297,10.2545475 0.0443219956,10.7031464 C0.164518321,11.1517453 0.514898243,11.502141 0.963477036,11.6223427 C1.41205583,11.7425444 1.8906837,11.6142907 2.21906617,11.2858935 L7.63294433,5.86967791 C8.81017097,6.29439677 10.1273694,5.94678336 10.941753,4.99647138 C11.7561366,4.04615939 11.8979726,2.69121172 11.2980456,1.59283637 L11.297522,1.59335998 Z"
                            id="Path"
                          ></path>
                        </g>
                      </g>
                    </g>
                    <g id="Vorkommen" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000, 46.000000)">
                      <text
                        id="Fleisch,-Fisch,-Eier"
                        fontFamily="Helvetica"
                        fontSize="16"
                        fontWeight="normal"
                        line-spacing="24"
                        fill="#222222"
                      >
                        <tspan x="19" y="19">
                          {t("card.line_2")}
                        </tspan>
                      </text>
                      <text
                        id="1.200-mg-(Ø-800-mg)"
                        fontFamily="Helvetica"
                        fontSize="16"
                        fontWeight="normal"
                        line-spacing="24"
                        fill="#222222"
                      >
                        <tspan x="19" y="43">
                          {t("card.line_3")}
                        </tspan>
                      </text>
                      <g
                        id="Group"
                        transform="translate(0.000000, 6.000000)"
                        stroke="#222222"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.16666667"
                      >
                        <g id="Overrides/Icons/Others/Ernährung">
                          <path
                            d="M11.4361112,3.35120564 C10.8036326,3.17053337 10.1208729,3.31961395 9.62628689,3.74638076 C9.31882605,2.57149682 8.23907407,1.75 7.00230099,1.75 C5.76552791,1.75 4.68577593,2.57149682 4.37831509,3.74638076 C3.87384785,3.31395444 3.17733725,3.16793183 2.53669254,3.36028679 C1.89604784,3.55264176 1.40226176,4.05605355 1.23108774,4.69134263 C1.07707338,5.2641316 1.20264311,5.87458603 1.57104006,6.34401335 C1.93943702,6.81344067 2.50899543,7.08874853 3.11299383,7.08934867 C3.2442338,7.08437051 3.37458463,7.06596135 3.50192454,7.03442085 L3.50192454,11.4871137 C3.50192454,11.9084442 3.85018497,12.25 4.27978598,12.25 L9.724816,12.25 C10.154417,12.25 10.5026774,11.9084442 10.5026774,11.4871137 L10.5026774,7.03442085 C10.6300247,7.06592501 10.7603716,7.08433362 10.8916082,7.08934867 C11.8582527,7.08759088 12.6769193,6.38992895 12.8136237,5.4514205 C12.9503281,4.51291205 12.3635881,3.61834294 11.4361112,3.35120564 Z"
                            id="Path"
                          ></path>
                          <line x1="8.06496892" y1="10.3306732" x2="8.06496892" y2="7.99025099" id="Path"></line>
                          <line x1="5.94375717" y1="10.3306732" x2="5.94375717" y2="7.99025099" id="Path-Copy"></line>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Werte" mask="url(#mask-difr74wstm-2)">
                  <g transform="translate(0.000000, 130.000000)">
                    <rect id="Mask-Copy" fill="#F6F6F6" x="0" y="0" width="330" height="82"></rect>
                    <g id="Bedarf-Genetik" strokeWidth="1" fill="none" transform="translate(20.000000, 10.000000)">
                      <text id="Veranlagung" fontFamily="Helvetica" fontSize="14" fontWeight="bold" fill="#222222">
                        <tspan x="0" y="14">
                          {t("card.bottom_line_1")}
                        </tspan>
                      </text>
                      <text
                        id="Erhöhter-Bedarf"
                        fontFamily="Helvetica"
                        fontSize="14"
                        fontWeight="normal"
                        fill="#222222"
                      >
                        <tspan x="0" y="32">
                          {t("card.bottom_line_2")}
                        </tspan>
                      </text>
                      <g id="UI-Elements/Level-Bar/3-von-5-Copy-2" transform="translate(0.000000, 46.000000)">
                        <mask id="mask-difr74wstm-4" fill="white">
                          <use href="#path-difr74wstm-3"></use>
                        </mask>
                        <g id="BG"></g>
                        <g id="Group" mask="url(#mask-difr74wstm-4)" fill="#82BECC">
                          <g transform="translate(0.000000, 2.000000)">
                            <rect id="Rectangle" x="0" y="0" width="24" height="6"></rect>
                            <rect id="Rectangle-Copy" x="27" y="0" width="24" height="6"></rect>
                            <rect id="Rectangle-Copy-2" x="54" y="0" width="24" height="6"></rect>
                            <rect id="Rectangle-Copy-3" x="81" y="0" width="24" height="6"></rect>
                            <rect id="Rectangle-Copy-5" x="108" y="0" width="24" height="6"></rect>
                          </g>
                        </g>
                      </g>
                    </g>
                    <g id="Blutanalyse" strokeWidth="1" fill="none" transform="translate(178.000000, 10.000000)">
                      <text id="Aktueller-Wert" fontFamily="Helvetica" fontSize="14" fontWeight="bold" fill="#222222">
                        <tspan x="0" y="14">
                          {t("card.bottom_line_3")}
                        </tspan>
                      </text>
                      <text
                        id="Leichter-Mangel"
                        fontFamily="Helvetica"
                        fontSize="14"
                        fontWeight="normal"
                        fill="#222222"
                      >
                        <tspan x="0" y="32">
                          {t("card.bottom_line_4")}
                        </tspan>
                      </text>
                      <g id="UI-Elements/Level-Bar/3-von-5-Copy" transform="translate(0.000000, 46.000000)">
                        <rect id="Rectangle" fill="#D2D2D2" x="0" y="2" width="132" height="6" rx="3"></rect>
                        <rect
                          id="Rectangle-Copy-2"
                          fill="#A75151"
                          x="0"
                          y="2"
                          width="39.1111111"
                          height="6"
                          rx="3"
                        ></rect>
                        <circle
                          id="Oval-Copy"
                          stroke="#F6F6F6"
                          strokeWidth="2"
                          fill="#D2D2D2"
                          cx="72.0555556"
                          cy="5"
                          r="6"
                        ></circle>
                        <circle
                          id="Oval"
                          stroke="#F6F6F6"
                          strokeWidth="2"
                          fill="#A75151"
                          cx="37.0555556"
                          cy="5"
                          r="6"
                        ></circle>
                      </g>
                      <g id="Icons/Level/Medium-Copy" transform="translate(116.000000, 21.000000)">
                        <circle id="Oval" fill="#A75151" cx="8" cy="8" r="8"></circle>
                        <g
                          id="Group"
                          transform="translate(8.300000, 8.215223) scale(1, -1) translate(-8.300000, -8.215223) translate(5.000000, 5.022222)"
                          stroke="#FFFFFF"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.33333333"
                        >
                          <path
                            d="M4.62032593,0.977777778 C4.62459259,1.06145185 4.62032593,1.26222222 4.62032593,1.34613333 C4.62908487,3.96003315 3.54937021,6.89439832 0,6.31111111"
                            id="Path"
                          ></path>
                          <polyline id="Path" points="2.6 2 4.6 0 6.6 2"></polyline>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Group" mask="url(#mask-difr74wstm-2)" strokeLinecap="round" strokeLinejoin="round">
                  <g transform="translate(21, 93)" id="Overrides/Icons/Others/Ernährung-Copy-2">
                    <g id="Group" transform="translate(2.625000, 1.166667)" stroke="#222222" strokeWidth="1.16666667">
                      <line x1="1.59090909" y1="0" x2="1.59090909" y2="11.6666667" id="Path"></line>
                      <path
                        d="M3.18181818,0 L3.18181818,3.5 C3.17919732,4.3580459 2.46845603,5.05299293 1.59090909,5.05555556 L1.59090909,5.05555556 C0.713362152,5.05299293 0.00262086452,4.3580459 0,3.5 L0,0"
                        id="Path"
                      ></path>
                      <line x1="7.15909091" y1="5.05555556" x2="7.15909091" y2="11.6666667" id="Path"></line>
                      <rect
                        id="Rectangle"
                        x="5.56818182"
                        y="0"
                        width="3.18181818"
                        height="5.05555556"
                        rx="1.03703704"
                      ></rect>
                    </g>
                  </g>
                </g>
              </g>
              <g id="Rechts" transform="translate(572.073007, 21.000000)">
                <g id="Analyse" transform="translate(0.926993, 65.000000)">
                  <text
                    id="Das-Ergebnis-deiner"
                    fontFamily="Helvetica"
                    fontSize="14"
                    fontWeight="normal"
                    fill="#222222"
                  >
                    <tspan x="0" y="14">
                      {t("descriptions.center_right.line_1")}{" "}
                    </tspan>
                    <tspan x="0" y="31">
                      {t("descriptions.center_right.line_2")}{" "}
                    </tspan>
                    <tspan
                      x="0"
                      y="48"
                      dangerouslySetInnerHTML={{ __html: t("descriptions.center_right.line_3") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="65"
                      dangerouslySetInnerHTML={{ __html: t("descriptions.center_right.line_4") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="82"
                      dangerouslySetInnerHTML={{ __html: t("descriptions.center_right.line_5") }}
                    ></tspan>
                    <tspan x="0" y="99">
                      {t("descriptions.center_right.line_6")}{" "}
                    </tspan>
                    <tspan
                      x="0"
                      y="116"
                      dangerouslySetInnerHTML={{ __html: t("descriptions.center_right.line_7") }}
                    ></tspan>
                    <tspan
                      x="0"
                      y="133"
                      dangerouslySetInnerHTML={{ __html: t("descriptions.center_right.line_8") }}
                    ></tspan>
                  </text>
                  <circle
                    id="Oval-Copy"
                    stroke="#F6F6F6"
                    strokeWidth="2"
                    fill="#D2D2D2"
                    cx={t("descriptions.center_right.icon_3.cx")}
                    cy={t("descriptions.center_right.icon_3.cy")}
                    r="6"
                  ></circle>
                  <circle
                    id="Oval"
                    stroke="#F6F6F6"
                    strokeWidth="2"
                    fill="#A75151"
                    cx={t("descriptions.center_right.icon_1.cx")}
                    cy={t("descriptions.center_right.icon_1.cy")}
                    r="6"
                  ></circle>
                  <circle
                    id="Oval-Copy-2"
                    stroke="#F6F6F6"
                    strokeWidth="2"
                    fill="#82BECC"
                    cx={t("descriptions.center_right.icon_2.cx")}
                    cy={t("descriptions.center_right.icon_2.cy")}
                    r="6"
                  ></circle>
                </g>
                <text id="Trend-fallend-Trend" fontFamily="Helvetica" fontSize="14" fontWeight="normal" fill="#222222">
                  <tspan x="19.9269931" y="251">
                    {t("descriptions.bottom_right.line_1")}
                  </tspan>
                  <tspan x="19.9269931" y="268">
                    {t("descriptions.bottom_right.line_2")}
                  </tspan>
                </text>
                <text id="Hier-kannst-du-mehr" fontFamily="Helvetica" fontSize="14" fontWeight="normal" fill="#222222">
                  <tspan x="0.926993128" y="14">
                    {t("descriptions.top_right.line_1")}
                  </tspan>
                  <tspan x="0.926993128" y="31">
                    {t("descriptions.top_right.line_2")}
                  </tspan>
                </text>
                <g id="Icons/Level/Blut/4" transform="translate(2.000000, 239.000000)">
                  <circle id="Oval" fill="#A75151" cx="7" cy="7" r="7"></circle>
                  <g
                    id="Group"
                    transform="translate(7.262500, 7.188320) scale(1, -1) translate(-7.262500, -7.188320) translate(4.375000, 4.394444)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.16666667"
                  >
                    <path
                      d="M4.04278519,0.855555556 C4.04651852,0.92877037 4.04278519,1.10444444 4.04278519,1.17786667 C4.05044926,3.465029 3.10569893,6.03259853 0,5.52222222"
                      id="Path"
                    ></path>
                    <polyline id="Path" points="2.275 1.75 4.025 0 5.775 1.75"></polyline>
                  </g>
                </g>
                <g id="Icons/Level/Blut/4-Copy" transform="translate(2.000000, 256.000000)">
                  <circle id="Oval" fill="#82BECC" cx="7" cy="7" r="7"></circle>
                  <g
                    id="Group"
                    transform="translate(4.375000, 3.811111)"
                    stroke="#FFFFFF"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.16666667"
                  >
                    <path
                      d="M4.04278519,0.855555556 C4.04651852,0.92877037 4.04278519,1.10444444 4.04278519,1.17786667 C4.05044926,3.465029 3.10569893,6.03259853 0,5.52222222"
                      id="Path"
                    ></path>
                    <polyline id="Path" points="2.275 1.75 4.025 0 5.775 1.75"></polyline>
                  </g>
                </g>
              </g>
              <g id="Links" transform="translate(0.000000, 1.000000)">
                <text id="Die-Hauptfunktion-de" fontFamily="Helvetica" fontSize="14" fontWeight="normal" fill="#222222">
                  <tspan x={t("descriptions.top_left.line_1_x")} y="14">
                    {t("descriptions.top_left.line_1")}
                  </tspan>
                  <tspan
                    x={t("descriptions.top_left.line_2_x")}
                    y="31"
                    dangerouslySetInnerHTML={{ __html: t("descriptions.top_left.line_2") }}
                  ></tspan>
                  <tspan
                    x={t("descriptions.top_left.line_3_x")}
                    y="48"
                    dangerouslySetInnerHTML={{ __html: t("descriptions.top_left.line_3") }}
                  ></tspan>
                  <tspan
                    x={t("descriptions.top_left.line_4_x")}
                    y="65"
                    dangerouslySetInnerHTML={{ __html: t("descriptions.top_left.line_4") }}
                  ></tspan>
                </text>
                <g
                  id="Group"
                  transform={`translate(${t("descriptions.top_left.nutrient_icon.x")}.000000, ${t(
                    "descriptions.top_left.nutrient_icon.y",
                  )}.000000)`}
                  stroke="#222222"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g id="Group" transform="translate(1.000000, 1.000000)">
                    <path
                      d="M9.6835903,1.36573713 L8.1949608,2.85398463 L7.14569467,2.85398463 L7.14569467,1.8046714 L8.63387538,0.315975093 C7.69245304,-0.198271091 6.53112145,-0.0766919494 5.71660488,0.621382477 C4.9020883,1.3194569 4.60414733,2.44853477 4.96817572,3.45763146 L0.326362363,8.09785792 C0.0448916766,8.37934124 -0.0650351397,8.78961211 0.0379902819,9.17412548 C0.141015704,9.55863884 0.441341351,9.85897797 0.825837459,9.96200801 C1.21033357,10.0650381 1.62058603,9.95510631 1.90205672,9.67362299 L6.54252371,5.03115249 C7.55157512,5.39519723 8.68060231,5.09724288 9.37864541,4.28268975 C10.0766885,3.46813662 10.1982622,2.30675291 9.68403909,1.36528832 L9.6835903,1.36573713 Z"
                      id="Path"
                    ></path>
                  </g>
                </g>
                <text id="Dein-persönlicher-Ta" fontFamily="Helvetica" fontSize="14" fontWeight="normal" fill="#222222">
                  <tspan x={t("descriptions.center_left.line_1_x")} y="116">
                    {t("descriptions.center_left.line_1")}
                  </tspan>
                  <tspan
                    x={t("descriptions.center_left.line_2_x")}
                    y="133"
                    dangerouslySetInnerHTML={{ __html: t("descriptions.center_left.line_2") }}
                  ></tspan>
                  <tspan x={t("descriptions.center_left.line_3_x")} y="150">
                    {t("descriptions.center_left.line_3")}
                  </tspan>
                  <tspan x={t("descriptions.center_left.line_4_x")} y="167">
                    {t("descriptions.center_left.line_4")}
                  </tspan>
                </text>
                <g
                  id="Group"
                  transform={`translate(${t("descriptions.center_left.cutlery_icon.x")}.000000, ${t(
                    "descriptions.center_left.cutlery_icon.y",
                  )}.000000)`}
                  stroke="#222222"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g id="Group" transform="translate(2.250000, 1.000000)">
                    <line x1="1.36363636" y1="0" x2="1.36363636" y2="10" id="Path"></line>
                    <path
                      d="M2.72727273,0 L2.72727273,3 C2.72502627,3.73546791 2.11581945,4.3311368 1.36363636,4.33333333 L1.36363636,4.33333333 C0.611453273,4.3311368 0.0022464553,3.73546791 0,3 L0,0"
                      id="Path"
                    ></path>
                    <line x1="6.13636364" y1="4.33333333" x2="6.13636364" y2="10" id="Path"></line>
                    <rect
                      id="Rectangle"
                      x="4.77272727"
                      y="0"
                      width="2.72727273"
                      height="4.33333333"
                      rx="0.888888889"
                    ></rect>
                  </g>
                </g>
                <g
                  id="Group"
                  transform={`translate(${t("descriptions.top_left.chef_icon.x")}, ${t(
                    "descriptions.top_left.chef_icon.y",
                  )})`}
                  stroke="#222222"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <g id="Overrides/Icons/Others/Ernährung">
                    <path
                      d="M9.80238099,2.87246198 C9.26025654,2.71760003 8.6750339,2.84538339 8.25110305,3.21118351 C7.98756518,2.20414013 7.06206349,1.5 6.00197228,1.5 C4.94188107,1.5 4.01637937,2.20414013 3.75284151,3.21118351 C3.32044101,2.84053238 2.72343193,2.71537014 2.1743079,2.88024582 C1.62518387,3.04512151 1.20193865,3.47661733 1.05521806,4.02115083 C0.923205757,4.5121128 1.03083695,5.03535946 1.34660577,5.43772573 C1.66237459,5.840092 2.15056751,6.07607017 2.66828042,6.07658457 C2.78077183,6.07231758 2.89250111,6.0565383 3.00164961,6.02950359 L3.00164961,9.84609743 C3.00164961,10.2072378 3.30015855,10.5 3.66838798,10.5 L8.33555657,10.5 C8.70378601,10.5 9.00229494,10.2072378 9.00229494,9.84609743 L9.00229494,6.02950359 C9.11144972,6.05650715 9.22317566,6.07228596 9.33566413,6.07658457 C10.1642166,6.0750779 10.8659308,5.47708196 10.9831061,4.67264614 C11.1002813,3.86821033 10.5973612,3.1014368 9.80238099,2.87246198 Z"
                      id="Path"
                    ></path>
                    <line x1="6.9128305" y1="8.85486277" x2="6.9128305" y2="6.84878656" id="Path"></line>
                    <line x1="5.094649" y1="8.85486277" x2="5.094649" y2="6.84878656" id="Path-Copy"></line>
                  </g>
                </g>
                <text id="Deine-Genanalyse-zei" fontFamily="Helvetica" fontSize="14" fontWeight="normal" fill="#222222">
                  <tspan x={t("descriptions.bottom_left.line_1_x")} y="218">
                    {t("descriptions.bottom_left.line_1")}
                  </tspan>
                  <tspan x={t("descriptions.bottom_left.line_2_x")} y="235">
                    {t("descriptions.bottom_left.line_2")}
                  </tspan>
                  <tspan x={t("descriptions.bottom_left.line_3_x")} y="252">
                    {t("descriptions.bottom_left.line_3")}
                  </tspan>
                  <tspan x={t("descriptions.bottom_left.line_4_x")} y="269">
                    {t("descriptions.bottom_left.line_4")}
                  </tspan>
                </text>
              </g>
              <text id="Um-diesen-Nährstoff" fontFamily="Helvetica" fontSize="14" fontWeight="normal" fill="#222222">
                <tspan x="337" y="14">
                  {t("descriptions.top_center.line_1")}
                </tspan>
              </text>
              <path
                d="M228.535913,85.0495809 C227.588913,84.8495809 226.938913,86.1575809 227.853913,86.6695809 C229.264913,87.4585809 230.675913,88.1455809 232.117913,88.7535809 C219.830678,89.1492365 207.729213,92.6794906 197.221387,98.9262527 C195.609083,99.8847453 196.478725,100.935434 198.00025,100.05817 C209.274545,93.5577635 222.123574,90.1539237 235.513913,90.4685809 C234.061913,91.1095809 232.609913,91.7505809 231.157913,92.3915809 C230.103913,92.8555809 231.015913,94.4015809 232.062913,93.9395809 C234.783913,92.7385809 237.504913,91.5375809 240.225913,90.3365809 C240.809913,90.0785809 240.816913,89.0435809 240.225913,88.7885809 C236.431913,87.1475809 232.584913,85.9045809 228.535913,85.0495809 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(218.512311, 92.707990) scale(-1, -1) rotate(50.000000) translate(-218.512311, -92.707990) "
              ></path>
              <path
                d="M227.320414,150.903656 C226.373414,150.703656 225.723414,152.011656 226.638414,152.523656 C228.049414,153.312656 229.460414,153.999656 230.902414,154.607656 C218.396857,155.010341 210.292922,158.301945 201.865392,163.98807 C200.741989,164.74604 201.584727,165.83505 202.587061,165.185983 C213.000655,158.442601 220.435335,155.99689 234.298414,156.322656 C232.846414,156.963656 231.394414,157.604656 229.942414,158.245656 C228.888414,158.709656 229.800414,160.255656 230.847414,159.793656 C233.568414,158.592656 236.289414,157.391656 239.010414,156.190656 C239.594414,155.932656 239.601414,154.897656 239.010414,154.642656 C235.216414,153.001656 231.369414,151.758656 227.320414,150.903656 Z"
                id="Fill-1-Copy-2"
                fill="#000000"
                transform="translate(220.390702, 158.133602) scale(-1, -1) rotate(20.000000) translate(-220.390702, -158.133602) "
              ></path>
              <path
                d="M303.263952,33.8271869 C305.600952,36.0821869 307.001952,39.1921869 306.240952,42.4701869 C305.083952,47.4461869 299.355952,48.6051869 295.897952,45.0601869 C291.531952,40.5841869 294.508952,34.1671869 298.463952,30.4861869 C300.235952,31.3731869 301.861952,32.4741869 303.263952,33.8271869 M332.616952,23.0801869 C328.914952,20.5051869 325.003952,18.5271869 320.751952,17.0481869 C319.803952,16.7191869 319.225952,18.1651869 320.076952,18.6501869 C321.749952,19.6041869 323.442952,20.5041869 325.156952,21.3631869 C315.942952,20.8681869 304.290952,22.5431869 297.466952,28.7241869 C294.903952,27.7591869 292.185952,27.1601869 289.640952,26.7951869 C273.530952,24.4821869 260.172952,33.4821869 249.163952,44.2091869 C248.888952,44.4771869 249.298952,44.8771869 249.580952,44.6271869 C256.782952,38.2471869 264.364952,31.8361869 273.779952,29.0751869 C280.504952,27.1021869 289.413952,26.8351869 296.532952,29.6321869 C295.146952,31.0761869 294.001952,32.7341869 293.183952,34.6411869 C291.366952,38.8841869 291.813952,44.1851869 295.694952,47.1031869 C298.873952,49.4931869 303.484952,49.5331869 306.109952,46.3291869 C309.141952,42.6271869 308.175952,37.1881869 305.226952,33.7911869 C303.673952,32.0031869 301.688952,30.6411869 299.511952,29.5971869 C299.664952,29.4781869 299.815952,29.3521869 299.968952,29.2431869 C308.341952,23.2701869 319.867952,21.9661869 329.775952,23.5391869 C329.872952,23.5541869 329.967952,23.5461869 330.059952,23.5301869 C330.240952,23.6461869 330.421952,23.7631869 330.601952,23.8821869 C328.934952,25.0261869 327.220952,25.8251869 325.224952,26.3931869 C324.125952,26.7061869 324.592952,28.4241869 325.697952,28.1081869 C328.415952,27.3321869 330.571952,26.2061869 332.795952,24.4721869 C333.282952,24.0931869 333.029952,23.3681869 332.616952,23.0801869"
                id="Fill-1"
                fill="#000000"
                transform="translate(291.067749, 32.911499) rotate(-17.000000) translate(-291.067749, -32.911499) "
              ></path>
              <path
                d="M216.621529,230.970122 C214.585805,221.096779 213.774316,211.101633 213.768046,201.05604 C213.766758,198.991991 212.826419,198.964137 212.752399,201.013351 C212.428699,209.974775 213.082589,218.888489 214.403529,227.763122 C213.680529,226.484122 212.958529,225.204122 212.232529,223.927122 C211.743529,223.067122 210.325529,223.639122 210.619529,224.607122 C211.689529,228.115122 213.174529,231.122122 215.352529,234.096122 C215.726529,234.607122 216.521529,234.719122 216.872529,234.096122 C218.265529,231.627122 219.667529,229.163122 221.040529,226.683122 C221.579529,225.709122 220.102529,224.843122 219.546529,225.810122 C218.560529,227.523122 217.592529,229.248122 216.621529,230.970122 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(215.868355, 217.007256) rotate(-270.000000) translate(-215.868355, -217.007256) "
              ></path>
              <path
                d="M555.360762,208.625721 C552.213667,213.539417 542.294588,229.371469 536.736588,238.068469 C536.043588,235.117469 535.346588,232.166469 534.646588,229.216469 C534.420588,228.262469 532.792588,228.440469 532.899588,229.452469 C533.396588,234.148469 533.892588,238.843469 534.389588,243.538469 C534.471588,244.319469 535.294588,244.694469 535.907588,244.167469 C539.898588,240.739469 543.898588,237.319469 547.877588,233.876469 C548.739588,233.130469 547.488588,231.895469 546.629588,232.628469 C543.070588,235.663469 539.527588,238.718469 535.980588,241.767469 C535.954588,241.520469 535.928588,241.273469 535.902588,241.026469 C536.292588,241.244469 536.852588,241.148469 537.117588,240.729469 C543.685588,230.309469 550.248588,219.887469 556.806588,209.460469 C559.911588,204.522469 558.507857,203.712024 555.360762,208.625721 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(545.720351, 224.867807) rotate(-120.000000) translate(-545.720351, -224.867807) "
              ></path>
              <path
                d="M562.296307,46.6846469 C562.200307,46.5446469 562.055307,46.4446469 561.859307,46.4096469 C559.739307,45.0766469 557.619307,43.7436469 555.499307,42.4096469 C554.519307,41.7936469 553.618307,43.3456469 554.594307,43.9576469 C555.961307,44.8166469 557.328307,45.6756469 558.695307,46.5336469 C549.571307,46.7936469 538.802642,45.5909419 531.13459,41.5966866 C524.942891,38.3714572 523.632201,35.9408609 520.997369,29.720434 C520.563809,28.6968673 519.656951,28.665036 520.089659,30.2695033 C521.350102,34.9431805 523.233883,38.9227966 527.494789,41.5966866 C536.864642,47.4766469 547.383307,48.4626469 558.704307,48.2206469 C556.782307,49.4866469 554.810307,50.6526469 552.737307,51.7106469 C551.826307,52.1766469 552.469307,53.5636469 553.418307,53.3256469 C557.077307,52.4106469 560.354307,51.0216469 563.556307,49.0206469 C564.135307,48.6586469 564.132307,47.8386469 563.556307,47.4766469 C563.136307,47.2126469 562.716307,46.9486469 562.296307,46.6846469 Z"
                id="Fill-1"
                fill="#000000"
                transform="translate(541.982500, 41.176361) scale(1, -1) translate(-541.982500, -41.176361) "
              ></path>
              <text id="*-Basierend-auf-den" fontFamily="Helvetica" fontSize="12" fontWeight="normal" fill="#222222">
                <tspan x="290" y="294">
                  {t("descriptions.bottom_center.line_1")}
                </tspan>
                <tspan x="290" y="308">
                  {t("descriptions.bottom_center.line_2")}
                </tspan>
              </text>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
